module.exports = __webpack_public_path__ + "img/ddos-c.7eebc2f 1.fb3595e.svg";